// src/components/RequireFeature.jsx
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const RequireFeature = ({ children, feature }) => {
  const { hasFeature, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (!loading && !hasFeature(feature)) {
      toast.error(t('feature_locked_message') || 'This feature is not available in your current plan. Please upgrade to access.', {
        id: `feature-locked-${feature}`
      });
    }
  }, [loading, hasFeature, feature, t]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
      </div>
    );
  }

  if (!hasFeature(feature)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default RequireFeature;
